/*
 * A person's name as the app shows it.
 *
 * Deleting an account keeps everything its holder made -- isolates, plates,
 * photographs, identifications -- attributed to the same row, de-identified:
 * routes/account_lifecycle.py::deidentify renames it `deleted-<32 hex>` (the
 * user id's hex) and clears its full name. That name means nothing to a
 * reader, so it is shown as "Deleted user". (utils/passwordRules.js refuses a
 * username starting `deleted-`, so no living account can look like one.)
 */
export const DELETED_NAME = /^deleted-[0-9a-f]+$/;

export const isDeletedName = (name) => typeof name === 'string' && DELETED_NAME.test(name);

/** `name`, or "Deleted user" for a deleted account's anonymised name.
 *  (GET /users/names lists active accounts only, so the pickers it fills never
 *  hold a deleted one; this is for names a record carries.) */
export function displayName(name, t) {
  return isDeletedName(name) ? t('common:deletedUser') : name;
}
